/**
 * @generated SignedSource<<c44e9a532652073acab3a9e55b231b2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteHydrantModelInput = {
  hydrantModelId: string;
  clientMutationId?: string | null;
};
export type HydrantModelsTableDeleteHydrantModelMutation$variables = {
  input: DeleteHydrantModelInput;
};
export type HydrantModelsTableDeleteHydrantModelMutationVariables = HydrantModelsTableDeleteHydrantModelMutation$variables;
export type HydrantModelsTableDeleteHydrantModelMutation$data = {
  readonly deleteHydrantModel: {
    readonly hydrantModel: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type HydrantModelsTableDeleteHydrantModelMutationResponse = HydrantModelsTableDeleteHydrantModelMutation$data;
export type HydrantModelsTableDeleteHydrantModelMutation = {
  variables: HydrantModelsTableDeleteHydrantModelMutationVariables;
  response: HydrantModelsTableDeleteHydrantModelMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHydrantModelPayload",
    "kind": "LinkedField",
    "name": "deleteHydrantModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantModel",
        "kind": "LinkedField",
        "name": "hydrantModel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HydrantModelsTableDeleteHydrantModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HydrantModelsTableDeleteHydrantModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2a9a10f37b5b24b160e7268fb4d4149",
    "id": null,
    "metadata": {},
    "name": "HydrantModelsTableDeleteHydrantModelMutation",
    "operationKind": "mutation",
    "text": "mutation HydrantModelsTableDeleteHydrantModelMutation(\n  $input: DeleteHydrantModelInput!\n) {\n  deleteHydrantModel(input: $input) {\n    hydrantModel {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3f6ecb85f3ddcb031e912f84df78811";

export default node;
